/**
 * Auth endpoint wrappers — the saas-auth session surface (H §4.2).
 *
 * `refresh` runs on cold boot, on the proactive timer and (inside the factory) on every
 * bounded 401 retry; `client.ts` fetches a fresh CSRF token before each refresh and
 * single-flights it. `logout` primes CSRF first (so a token another tab rotated is never
 * sent), then posts; both go through `request`, so they carry `credentials:'include'` and
 * `X-CSRF-Token` automatically.
 */
import { primeCsrf, request } from './client';
import type { AuthTokenResponse } from './types';

export const authApi = {
  refresh(): Promise<AuthTokenResponse> {
    return request<AuthTokenResponse>('POST', '/api/auth/refresh', { json: {} });
  },

  async logout(): Promise<void> {
    await primeCsrf();
    return request<void>('POST', '/api/auth/logout', { json: {} });
  },
};
